function QuoteStart({ small }) {
  return (
    <svg
      width={small ? "2em" : "4em"}
      height={small ? "2em" : "4em"}
      viewBox="0 0 37 31"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.564 29.04l8.745-28H5.57l-3.59 28h5.584zm18.598 0l8.743-28H24.168l-3.59 28h5.584z"
        fill="none"
        fillRule="nonzero"
        stroke="#0FB960"
        strokeWidth={2}
        fillOpacity={0}
      />
    </svg>
  );
}

export default QuoteStart;
